import JSZip from 'jszip';
export const downloadFile = (buffer, index) => {
    const blob = new Blob([buffer], { type: 'application/pdf' });
  
    let a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.target = '_blank';
    a.download = `codigoBarra${index + 1}.pdf`; // Cambiar el nombre de descarga si es necesario
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  
  export const downloadPDFCrude = (data) => { 
    const zip = new JSZip();
    const mainFolder = zip.folder('folder de crudo');
    for (const clientName in data) {
        if (data.hasOwnProperty(clientName)) {
            const clientData = data[clientName];
            for (const item in clientData) {
                if (clientData.hasOwnProperty(item)) {
                    const pdfData = clientData[item];
                    for (const pdfName in pdfData) {
                        if (pdfData.hasOwnProperty(pdfName)) {
                            const base64String = pdfData[pdfName];
                            const fileName = `${item}_${pdfName}`;
                            mainFolder.file(`${fileName}.pdf`, base64String, { base64: true });
                        }
                    }
                }
            }
        }
    }

    zip.generateAsync({ type: 'blob' }).then(content => {
        //const url = URL.createObjectURL(content);
        var reader = new FileReader();
        reader.readAsDataURL(content); 
        reader.onloadend = function() {
            const a = document.createElement('a');
            a.href = `data:application/zip;base64,${reader.result}`;;
            a.target = '_blank';
            a.download = `folder de crudo.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        

        //URL.revokeObjectURL(url);
    });
};




  
export const downloadPDFsRolledUp = (data, fileName) => {

    const bufferItem = data.pdf_item.data;
    const uint8ArrayItem = new Uint8Array(bufferItem);

    const bufferReel = data.pdf_reel.data;
    const uint8ArrayReel = new Uint8Array(bufferReel);
    
    const zip = new JSZip();
    const mainFolder = zip.folder(fileName);
    const reelsFolder = mainFolder.folder('PDFS | CARRETES');
    const boxesFolder = mainFolder.folder('PDFS | CAJAS');
    const boxes=data.boxes;

    if (data.unit === 'KG') {
       
    } else {
      boxesFolder.file(`Codigo de barras caja.pdf`, uint8ArrayItem);
  
      for (let i = 0; i < parseInt(data.number_reelsMT); i++) {
          reelsFolder.file(`Sticker carrete ${i + 1} | ${data.number_reelsMT}.pdf`, uint8ArrayReel);
      }  
      if(data.pdf_short!==null)
      {
        const bufferShort = data.pdf_short.data;
        const uint8ArrayShort = new Uint8Array(bufferShort);
        reelsFolder.file(`Sticker carrete corta.pdf`, uint8ArrayShort);
      }
    }

    zip.generateAsync({ type: 'blob' }).then(content => {
        const url = URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.download = `${fileName}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
    });
};
  

  
export const downloadExcelFile = (base64bytes, fileName) => {
    let a = document.createElement('A');
    a.href = `data:application/vnd.ms-excel;base64,${base64bytes}`;
    a.target = '_blank';
    a.download = `${fileName}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export const downloadPDFFile = (base64bytes, fileName) => {
    const a = document.createElement('a');
    a.href = `data:application/pdf;base64,${base64bytes}`;
    a.target = '_blank';
    a.download = `${fileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  